module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell",
    class: {
      'divide-line': _vm.divide
    },
    on: {
      "click": function($event) {
        _vm.$emit('click')
      }
    }
  }, [_c('div', {
    staticClass: "left",
    style: ({
      color: _vm.leftColor
    })
  }, [_vm._v(_vm._s(_vm.leftText))]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-042c05e1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/item-custom-right.vue
// module id = 816
// module chunks = 34